import { ReactNode } from "react";

import { Article } from "@phosphor-icons/react";
import { Input, Label, RichInput } from "@reactive-resume/ui";

import { useCoverLetterStore } from "@/client/stores/cover-letter";
import { CLCollapsibleSection } from "../../CollapsibleSection";

export const LetterContentSection = () => {
  const setValue = useCoverLetterStore((state) => state.setValue);
  const letter = useCoverLetterStore((state) => state.coverLetter.data.letter);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <Article size={18} />
      <h2 className="line-clamp-1 text-base font-bold text-gray-800 lg:text-xl">Letter</h2>
    </div>
  );

  const contentHTML: ReactNode = (
    <main className="grid gap-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label>Date</Label>
          <Input
            placeholder="March 31, 2026"
            value={letter.date}
            onChange={(event) => setValue("letter.date", event.target.value)}
          />
        </div>

        <div className="space-y-1.5">
          <Label>Subject Line</Label>
          <Input
            placeholder="Application for..."
            value={letter.subject}
            onChange={(event) => setValue("letter.subject", event.target.value)}
          />
        </div>
      </div>

      <div className="space-y-1.5">
        <Label>Greeting</Label>
        <Input
          placeholder="Dear Hiring Manager,"
          value={letter.greeting}
          onChange={(event) => setValue("letter.greeting", event.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Opening Paragraph</Label>
        <p className="text-xs text-muted-foreground">
          Hook the reader — mention the role, how you found it, and why you're excited.
        </p>
        <RichInput
          content={letter.opening}
          onChange={(value) => setValue("letter.opening", value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Body Paragraph</Label>
        <p className="text-xs text-muted-foreground">
          Prove your fit — specific achievements, skills, and measurable results.
        </p>
        <RichInput
          content={letter.body}
          onChange={(value) => setValue("letter.body", value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Closing Paragraph</Label>
        <p className="text-xs text-muted-foreground">
          Reiterate interest, propose next steps, and thank the reader.
        </p>
        <RichInput
          content={letter.closing}
          onChange={(value) => setValue("letter.closing", value)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label>Sign-Off</Label>
          <Input
            placeholder="Sincerely,"
            value={letter.signOff}
            onChange={(event) => setValue("letter.signOff", event.target.value)}
          />
        </div>

        <div className="space-y-1.5">
          <Label>Enclosures</Label>
          <Input
            placeholder="Encl: Resume, Portfolio"
            value={letter.enclosures}
            onChange={(event) => setValue("letter.enclosures", event.target.value)}
          />
        </div>
      </div>
    </main>
  );

  return (
    <CLCollapsibleSection
      id="cl-letter"
      defaultOpen={true}
      header={headerHTML}
      content={contentHTML}
    />
  );
};
